import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { GradientBorder } from 'client/components/GradientBorder/GradientBorder'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'

type TProps = {}

// const CATEGORIES = [
//   'Design',
//   'Programming',
//   'SMM',
//   'SEO',
//   'Workouts',
//   'Data Analytics',
//   'Self development',
//   'Copywriting',
// ]

const CATEGORIES = [
  'Дизайн',
  'Программирование',
  'SMM',
  'SEO',
  'Тренировки',
  'Аналитика данных',
  'Саморазвитие',
  'Копирайтинг',
]

const Categories: FC<TProps> = () => {
  return (
    <ResponsiveBlock className="my-16" contentClassName="justify-between flex-wrap">
      {CATEGORIES.map((item) => (
        <div key={item} className="flex">
          <GradientBorder className="flex h-10 w-36">
            <Text tagName="span" className="">
              {item}
            </Text>
          </GradientBorder>
        </div>
      ))}
    </ResponsiveBlock>
  )
}

export { Categories }
